import axios from 'axios';

import { useServicerStore } from '../store';

const ImportService = {
  async getImports({ page, limit }) {
    const response = await axios.get('/import', {
      params: {
        servicer_id: useServicerStore.getState()?.servicerId,
        page,
        per_page: limit,
        status: null,
      },
    });

    return response.data;
  },

  async createImport(formValues) {
    const response = await axios.post('/import', formValues);

    return response.data;
  },

  async getImport(id) {
    const response = await axios.get(`/import/${id}`);

    return response.data;
  },

  async deleteImport(id) {
    const response = await axios.delete(`/import/${id}`);

    return response.data;
  },

  async finalizeImport(id) {
    const response = await axios.post(`/import/${id}/finalize`);

    return response.data;
  },
};

export default ImportService;
